<template>
  <div
    v-if="panel"
    class="layer-item smart-panel"
    :class="[{ active: (isCurrentPost || isCurrentSamplePost) }, { queued: isQueuedPost }]"
    @click.stop="onSelect"
  >
    <div v-if="panel.type == 'graphic'" class="media" :style="{ backgroundImage: 'url(' + panelSettings.backgroundImage + ')' }">
      <span v-if="!panelSettings.backgroundImage" class="item-icon icon" :class="'icon-panel-' + panel.type"></span>
    </div>

      <div v-else class="media">
        <span class="item-icon icon" :class="'icon-panel-' + panel.type"></span>
        <template v-if="hasPlayButton">
          <button
            class="tb-btn tb-btn-contained on-image play-btn"
            @click.stop="togglePostVideo"
          >
            <span class="fas" :class="videoPlaying ? 'fa-pause' : 'fa-play'" />
          </button>
        </template>
      </div>

    <div class="item-title">{{item.title}}</div>

    <dropdown position="top right" class="more-actions ml-1">
      <template #trigger><button class="tb-btn tb-btn-text sm medium-em" title="More actions"><span class="fas fa-ellipsis-v"></span></button></template>
      <template #dropdown-body>
        <button
          class="dropdown-list-item"
          @click.stop="onClickRemove"
        >
          <span class="dropdown-list-item-label warning">
            Remove
          </span>
        </button>
      </template>
    </dropdown>
  </div>

  <div v-else class="layer-item deleted" :class="[{ active: (isCurrentPost || isCurrentSamplePost) }]">
    <div class="deleted-message">This Panel has been deleted.</div>

    <button
      class="tb-btn tb-btn-text sm medium-em actions ml-1"
      title="Remove item from playlist"
      @click.stop.prevent="onClickRemove"
    >
      <i class="fas fa-minus-circle"></i>
    </button>
  </div>
</template>

<script>
import timelineMixins from '../../../mixins/timeline-mixins';

export default {
  name: 'TimelinePostPanelComponent',
  mixins: [timelineMixins],
  props: ['item', 'parent', 'queuedPost'],

  methods: {
    onSelect() {
      this.$emit('select', {
        parent: this.layout.timeline_id,
        item: this.item,
      });
    },

    onClickRemove() {
      const { timeline_id: timelineId } = this.layout;
      const { timeline_id: subIndex } = this.item;
      this.removeThemePost({ timelineId, subIndex });
    },

    togglePostVideo() {
      const { item, layout } = this;

      this.playPausePostVideo({
        parent: layout.timeline_id,
        item,
      });
    },
  },

  computed: {
    panel() {
      return this.$store.state.panels.lookupTable[this.item._id];
    },

    panelSettings() {
      return this.panel?.settings || {};
    },

    isQueuedPost() {
      return ((this.queuedPost === this.item.timeline_id) && !(this.isCurrentPost || this.isCurrentSamplePost));
    },

    hasPlayButton() {
      return this.panel.type === 'timer' || this.panel.type === 'vimeo' || this.panel.type === 'youtube';
    },
  },
};
</script>
